import { lazy } from 'react'
import { LoopModule } from 'src/services/openApiV2'

// Marketing New UI
const MarketingNew = lazy(() => import('src/pages/members/MarketingNew/Marketing'))
const MarketingCampaignManagement = lazy(() => import('src/pages/members/MarketingCampaignManagement'))
const MarketingCompetitionAnalysis = lazy(() => import('src/pages/members/MarketingCompetitionAnalysis'))
const MarketingEvaluation = lazy(() => import('src/pages/members/MarketingNew/MarketingEvaluation'))
const MarketingTrends = lazy(() => import('src/pages/members/MarketingPages/Trends/Trends'))
const MarketingStoreMetrics = lazy(() => import('src/pages/members/MarketingPages/StoreMetrics/StoreMetrics'))
const MarketingCampaignMetrics = lazy(() => import('src/pages/members/MarketingPages/CampaignMetrics/CampaignMetrics'))
const MarketingConversionMetrics = lazy(() => import('src/pages/members/MarketingPages/ConversionMetrics/ConversionMetrics'))
const MarketingCompetitiveAnalysisItems = lazy(() => import('src/pages/members/MarketingPages/CompetitionAnalysisItems/CompetitionAnalysisItems'))
const MarketingCompetitiveAnalysisStores = lazy(() => import('src/pages/members/MarketingPages/CompetitionAnalysisStores/CompetitionAnalysisStores'))
const MarketingStoresRanking = lazy(() => import('src/pages/members/MarketingPages/StoresRanking/StoresRanking'))
const MarketingCOGS = lazy(() => import('src/pages/members/MarketingNew/Cogs'))
const Benchmarks = lazy(() => import('src/pages/members/Benchmarks/Benchmarks'))
const MarketingCustomerRetention = lazy(() => import('src/pages/members/CustomerRetention/CustomerRetention'))
const MarketingItemRetention = lazy(() => import('src/pages/members/CustomerRetention/ItemRetention'))
const Leaderboard = lazy(() => import('src/pages/members/Leaderboard'))
const HeadroomPage = lazy(() => import('src/pages/members/MarketingPages/HeadroomAnalysis/Components/HeadroomPage'))
const TruROIAgent = lazy(() => import('src/pages/members/Agents/TruROIAgent'))
const MarketingIntelligence = lazy(() => import('src/pages/members/MarketingIntelligence/MarketingIntelligence'))
const CustomerLifecycleValue = lazy(() => import('src/pages/members/CustomerLifecycleValue/CustomerLifecycleValue'))
const LoopChatApp = lazy(() => import('src/pages/members/Agents/LoopChatApp'))
const PlanGeneration = lazy(() => import('src/pages/members/PlanGeneration/PlanGeneration')) // v1 (internal only)
const PlanGenerationV2 = lazy(() => import('src/pages/members/PlanGenerationV2/PlanGeneration')) // v2 (default)
const PlanMonitoring = lazy(() => import('src/pages/members/PlanMonitoring/PlanMonitoring'))
const ScheduledReports = lazy(() => import('src/pages/members/ScheduledReports'))

export const truRoiRoutes = [
  {
    path: 'tru-roi',
    children: [
      { index: true, element: <MarketingNew /> },
      { path: 'new', element: <MarketingNew /> },
      {
        path: 'campaign-management',
        element: <MarketingCampaignManagement />
      },
      {
        path: 'competition-analysis',
        element: <MarketingCompetitionAnalysis />
      },
      {
        path: 'evaluation',
        element: <MarketingEvaluation />
      },
      {
        path: 'trends',
        element: <MarketingTrends />
      },
      {
        path: 'cogs',
        element: <MarketingCOGS />
      },
      {
        path: 'store-metrics',
        element: <MarketingStoreMetrics />
      },
      {
        path: 'campaign-metrics',
        element: <MarketingCampaignMetrics />
      },
      {
        path: 'conversion-metrics',
        element: <MarketingConversionMetrics />
      },
      {
        path: 'competition-analysis-items',
        element: <MarketingCompetitiveAnalysisItems />
      },
      {
        path: 'competition-analysis-stores',
        element: <MarketingCompetitiveAnalysisStores />
      },
      {
        path: 'stores-ranking',
        element: <MarketingStoresRanking />
      },
      {
        path: 'benchmarks',
        element: <Benchmarks module={LoopModule.TRUROI} />
      },
      {
        path: 'customer-retention',
        element: <MarketingCustomerRetention />
      },
      {
        path: 'item-retention',
        element: <MarketingItemRetention />
      },
      {
        path: 'leaderboard',
        element: <Leaderboard />
      },

      {
        path: 'headroom',
        element: <HeadroomPage />
      },
      {
        path: 'agent',
        children: [
          {
            index: true,
            element: <TruROIAgent />
          },
          {
            path: 'scheduled-reports',
            element: <ScheduledReports />
          }
        ]
      },
      {
        path: 'voice',
        element: <TruROIAgent voiceModeEnabled={true} />
      },
      {
        path: 'intelligence',
        element: <MarketingIntelligence />
      },
      {
        path: 'customer-lifecycle-value',
        element: <CustomerLifecycleValue />
      },
      {
        path: 'plan-generation',
        children: [
          {
            path: '/',
            element: <PlanGenerationV2 />
          },
          {
            path: 'new',
            element: <PlanGenerationV2 />
          },
          {
            path: 'v1',
            element: <PlanGeneration /> // v1 (internal only, redirects externals)
          },
          {
            path: 'management',
            element: <PlanMonitoring />
          }
        ]
      },
      {
        path: 'chat',
        element: <LoopChatApp />
      },
      {
        path: 'scheduled-reports',
        element: <ScheduledReports />
      }
    ]
  }
]


